//hr报表
import hrReport from '@/entrance/hrReport'
//人力资源
import hrResources from '@/entrance/hrResources'
//院长绩效
import jxwx from '@/entrance/jxwx'

//物流绩效
import wljx from '@/entrance/wljx'
//园林人才报表
import ylrc from '@/entrance/ylrc'
//医药物流
import yywl from '@/entrance/yywl'
import author from '@/hospital-admin/pages/author'
import departmentDetail from '@/hospital-admin/pages/department-detail'
import departmentFeedbackInfo from '@/hospital-admin/pages/department-feedback-info'
import departmentFeedbackRankInfo from '@/hospital-admin/pages/department-feedback-rank-info'
//医技预约(含患者随访系统)
// import HelloWorld from '@/entrance/HelloWorld'
//import hospitalAdmin from '@/entrance/hospital-admin'
import departmentInfo from '@/hospital-admin/pages/department-info'
import directorDetail from '@/hospital-admin/pages/director-detail'
import directorInfo from '@/hospital-admin/pages/director-info'
import hrDetails from '@/hrReport/hrDetails'

import hrList from '@/hrReport/hrList'
import allDepartment from '@/jxwx/components/allDepartment'
import allSort from '@/jxwx/components/allSort'
import chargeDetails from '@/jxwx/components/chargeDetails'
import chargeItemDetails from '@/jxwx/components/chargeItemDetails'
import depDetails from '@/jxwx/components/depDetails'
import details from '@/jxwx/components/details'
import groupDetails from '@/jxwx/components/groupDetails'
import itemDetail from '@/jxwx/components/itemDetail'
import dean from '@/jxwx/dean'
import director from '@/jxwx/director'
import teamLeader from '@/jxwx/teamLeader'
import hrm from '@/rlzy/hrm'
import proReport from '@/rlzy/proReport'
import logReport from '@/spd/logistics/logReport'


//患者随访
import hzsf from '@/entrance/hzsf'
import feedBackReport from '@/hzsf/feedBackReport'

//spd
import spd from '@/entrance/spd'
import orderReturnList from '@/spd/orderReturnList';
import orderReturnDetail from '@/spd/orderReturnDetail';
import orderReturnStep from '@/spd/orderReturnStep';

import returnDrugDetail from '@/spd/returnDrugDetail'
import wldetails from '@/wljx/components/details'
import whManager from '@/wljx/whManager'
import whTeamLeader from '@/wljx/whTeamLeader'
import whTeamMember from '@/wljx/whTeamMember'
import dateList from '@/ylrc/dateList'
import monthList from '@/ylrc/monthList'
import deliveryDetail from '@/yywl/deliveryDetail'
import deliveryReport from '@/yywl/deliveryReport'
import managementReport from '@/yywl/managementReport'
import Vue from 'vue'
import Router from 'vue-router'
import report from '../spd/logistics/report'
import reportPlus from '../spd/logistics/reportPlus'
import orderLostItems from "../spd/lost/orderLostItems"



Vue.use(Router)
  // 如果不用命名路由<router-link :to="{name: 'applename'}"> to apple</router-link>,name可以省略
  // 如果不用命名视图<router-view name="xxx"></router-link>,name可以省略
  // $router.name获取组件name值
  // name用于参数传递
let router = new Router({
  routes: [
    //院长绩效
    {
      path: '/jxwx',
      name: 'jxwx',
      component: jxwx,
      children: [{
          path: 'dean', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'dean',
          component: dean
        },
        {
          path: 'director',
          name: 'director',
          component: director
        },
        {
          path: 'teamLeader',
          name: 'teamLeader',
          component: teamLeader
        }, {
          path: 'chargeDetails',
          name: 'chargeDetails',
          component: chargeDetails
        }, {
          path: 'chargeItemDetails',
          name: 'chargeItemDetails',
          component: chargeItemDetails
        }, {
          path: 'itemDetail',
          name: 'itemDetail',
          component: itemDetail
        }, {
          path: 'details',
          name: 'details',
          component: details
        }, {
          path: 'allSort',
          name: 'allSort',
          component: allSort
        }, {
          path: 'allDepartment',
          name: 'allDepartment',
          component: allDepartment
        }, {
          path: 'depDetails',
          name: 'depDetails',
          component: depDetails
        }, {
          path: 'groupDetails',
          name: 'groupDetails',
          component: groupDetails
        }
      ]
    },
    {
      path: '/wljx',
      name: 'wljx',
      component: wljx,
      children: [{
        path: 'whManager',
        name: 'whManager',
        component: whManager
      }, {
        path: 'whTeamLeader',
        name: 'whTeamLeader',
        component: whTeamLeader
      }, {
        path: 'whTeamMember',
        name: 'whTeamMember',
        component: whTeamMember
      }, {
        path: 'details',
        name: 'details',
        component: wldetails
      }]
    },
    //医药物流
    {
      path: '/yywl',
      name: 'yywl',
      component: yywl,
      children: [{
        path: 'managementReport', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'managementReport',
        component: managementReport
      }, {
        path: 'deliveryReport', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'deliveryReport',
        component: deliveryReport
      }, {
        path: 'deliveryDetail', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'deliveryDetail',
        component: deliveryDetail
      }]
    },
    //SPD
    {
      path: '/spd',
      name: 'spd',
      component: spd,
      children: [{
          path: 'orderReturnList', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'orderReturnList',
          component: orderReturnList,
          meta: { title: "SPD退货列表" }
        },
        {
          path: 'orderReturnDetail', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'orderReturnDetail',
          component: orderReturnDetail,
          meta: { title: "SPD退货详情" }
        },
        {
          path: 'orderReturnStep', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'orderReturnStep',
          component: orderReturnStep,
          meta: { title: "SPD退货详情" }
        },
        {
          path: 'returnDrugDetail', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'returnDrugDetail',
          component: returnDrugDetail,
          meta: { title: "SPD退货药品详情" }
        },
        {
          path: 'lost/orderLostItems', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'orderLostItems',
          component: orderLostItems
        },

        // {
        //   path: 'logistics/distribute/rate',
        //   name: 'distributionRate',
        //   component: distributionRate
        // },
        // {
        //   path: 'logistics/sales/profit',
        //   name: 'salesProfit',
        //   component: salesProfit
        // },
        // {
        //   path: 'logistics/price/strategy',
        //   name: 'priceStrategy',
        //   component: priceStrategy
        // },
        {
          path: 'logistics/report',
          name: 'report',
          component: report,
          meta: { title: "SPD物流综合报表" }
        }, {
          path: 'logistics/reportPlus',
          name: 'reportPlus',
          component: reportPlus,
          meta: { title: "SPD物流综合报表" }
        }, {
          path: 'logReport',
          name: 'logReport',
          component: logReport,
          meta: { title: "SPD医院综合报表" }
        }
      ]
    },
    //hr报表
    {

      path: '/hrReport',
      name: 'hrReport',
      component: hrReport,
      children: [{
        path: 'hrList', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'hrList',
        component: hrList
      }, {
        path: 'hrDetails', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'hrDetails',
        component: hrDetails
      }]
    },

    //患者随访报表
    {
      path: '/hzsf',
      name: 'hzsf',
      component: hzsf,
      children: [{
        path: 'feedBackReport', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'feedBackReport',
        component: feedBackReport
      }]
    },

    {
      path: '/hrResources',
      name: 'hrResources',
      component: hrResources,
      children: [{
        path: 'proReport', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'proReport',
        component: proReport
      }, {
        path: 'hrm', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'hrm',
        component: hrm
      }]
    },
    //园林人才
    {
      path: '/ylrc',
      name: 'ylrc',
      component: ylrc,
      children: [{
        path: 'dateList', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'dateList',
        component: dateList
      }, {
        path: 'monthList', //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'monthList',
        component: monthList
      }, ]
    },
    //医技预约(含患者随访系统)
    {
      path: '/departmentInfo/',
      name: 'departmentInfo',
      component: departmentInfo
    },
    {
      path: '/departmentDetail/',
      name: 'departmentDetail',
      component: departmentDetail
    },
    {
      path: '/directorInfo/',
      name: 'directorInfo',
      component: directorInfo
    },
    {
      path: '/directorDetail',
      name: 'directorDetail',
      component: directorDetail
    },
    {
      path: '/author',
      name: 'author',
      component: author
    },
    {
      path: '/departmentFeedbackInfo',
      name: 'departmentFeedbackInfo',
      component: departmentFeedbackInfo
    },
    {
      path: '/departmentFeedbackRankInfo',
      name: 'departmentFeedbackRankInfo',
      component: departmentFeedbackRankInfo
    }




  ]
})

router.beforeEach((to, from, next) => {
  let code = () => {
    // 获取暂存的code信息
    return window.sessionStorage.getItem("weCode")
  }

  if (!code) {
    if (to.path !== '/author') {
      // 暂存进入链接，以便获取code后返回
      window.localStorage.setItem('authUrl', to.fullPath)
      next("/author")
      return false
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


router.routesArr = []
  // 后退到上一层页面，不是上一个历史
router.backward = function (stepNum) {
    typeof stepNum !== 'number' && (stepNum = 1)
    stepNum = Math.abs(stepNum)
    let index = router.routesArr.length - 1 - stepNum
    let route = router.routesArr[0]
    if (index > 0) {
      route = router.routesArr[index]
    }

    router.push({
      name: route.name,
      // path: route.path,
      params: { isBack: true },
      query: route.query
    })
  }
  // 判断某一个路由是否在轨迹中出现
router.getIndexOf = path => {
    for (let i in router.routesArr) {
      let route = router.routesArr[i]
      if (route.path === path) {
        return i
      }
    }
    return -1
  }
  // 记录用户浏览页面的地址的轨迹，只保留单一节点
router.afterEach((to, from) => {
  let index = router.getIndexOf(to.path)
  if (index !== -1) {
    router.routesArr.splice(index, 900)
  }
  router.routesArr.push(to)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js